import { Routes, Route } from "react-router-dom";
import Error from "../src/global/components/Error";
import { ErrorProvider } from "./global/contexts/ErrorContext";
import AapLearningApp from "./aapLearning/AapLearningApp";
import DirectoryApp from "./memberDirectory/DirectoryApp";
import IlpApp from "./ilp/IlpApp";
import NicuApp from "./nicu/NicuApp";
import ResolutionsApp from "./resolutions/ResolutionsApp";
import AccessDenied from "./global/components/AccessDenied";
import CphApp from "./cph/CphApp";
import AapReportsApp from "./aapReports/AapReportsApp";

export default function App() {
    return (
        <ErrorProvider>
            <Routes>
                <Route path="/aaplearning" element={<AapLearningApp />} />
                <Route path="/cph/:key" element={<CphApp />} />
                <Route path="/cph" element={<CphApp />} />
                <Route path="/ilp" element={<IlpApp />} />
                <Route path="/memberdirectory" element={<DirectoryApp />} />
                <Route path="/nicu" element={<NicuApp />} />
                <Route path="/resolutions" element={<ResolutionsApp />} /> 
                <Route path="/accessdenied" element={<AccessDenied />} />
                <Route path="/aapreports" element={<AapReportsApp />} />
                <Route path="*" element={<Error />} />
            </Routes>
        </ErrorProvider>
    );
}